// NATIVE
import * as React from 'react';

// INSTALLED
import { Formik, Form } from 'formik';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

// CUSTOM
import { useDispatch } from 'react-redux';
import { SnackAlert } from '../../SnackAlert';
import { closeSessionGlobal, hasPemissions } from '../../../commons/utils';
import MultipleSnackbars from '../../MultipleSnackbars';
import { storeEditNovedadesTurno } from '../../../store/novedadesTurnos';
import { EditarNovedadTurno } from '../../novedadesTurno/editar/EditarNovedadTurno';
import validationSchema from '../../novedadesTurno/formModels/editar/validationSchema';
import formInitialValues from '../../novedadesTurno/formModels/editar/formInitialValues';
import editNovedadesTurnoFormModel from '../../novedadesTurno/formModels/editar/editNovedadesTurnoFormModel';
import { ModalSessionExpired } from '../../generics/ModalSessionExpired';
import { timeToClosedToast } from '../../../commons';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export const EditDialogNovedadesTurnos = (props: any) => {
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [btnText, setBtnText] = React.useState('Editar Novedad Turno');

  const { open, handleCloseModalEditarTipoNovedad, buttons = false } = props;

  const { formId, formField } = editNovedadesTurnoFormModel;

  const currentValidationSchema = validationSchema[0];

  const dispatch = useDispatch();

  const [percentaje_area, setPercentajeArea] = React.useState(0);
  const [data, setMsgErrors] = React.useState([]);
  const [alert_snack, setAlertSnack] = React.useState(false);
  const [message_alert_snack, setMessageAlertSnack] = React.useState('');
  const [type_alert_snack, setTypeAlertSnack] = React.useState('success');

  const [areas_select, setAreasSelect] = React.useState([]);

  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [messagesAlerts, setMessagesAlerts] = React.useState<any>([]);

  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);

  const [msgSnack, setMsgSnack] = React.useState({
    msg: '',
    status: 'success',
  });

  const handleCloseT = () => {
    handleCloseModalEditarTipoNovedad(false);
  };

  const _handleSubmit = async (values: any, actions: any) => {
    const havePermissions = await hasPemissions(
      'modulo.thumano',
      'modulo.novedades',
      'edit',
      'modulo.novedadesturnos'
    );

    if (!havePermissions) {
      await validateLsPermissions('No tienes pemisos para (Editar) novedad turno.');

      return false;
    }

    setIsSubmitting(true);
    setBtnText('Un momento...');

    actions.setSubmitting(true);

    const response = await dispatch(storeEditNovedadesTurno(values));

    setBtnText('Editar Novedad Turno');
    setIsSubmitting(false);

    const result = await validateResponseCreate(response, ' (Editar Novedad Turno.) ');

    if (!result) {
      return false;
    }

    if (response.ok) {
      const errors: any = {
        msg: response.message,
        status: 'success',
      };

      await setMsgSnack(errors);
      await setAlertSnack(true);

      actions.resetForm();
      actions.setSubmitting(false);
      handleCloseModalEditarTipoNovedad(false);
    }
  };

  const validateLsPermissions = async (message: string) => {
    const errors: any = {
      msg: message,
      status: 'error',
    };

    await setMsgSnack(errors);
    await setAlertSnack(true);
  };

  const validateResponseCreate = async (response: any, textActionConcat: string) => {
    if (response.code == 401) {
      await localStorage.removeItem('lastSelectedQypht');
      await closeSessionGlobal();
      await handleCloseModalEditarTipoNovedad(false);
      setModalSessionExpired(true);
      return false;
    }

    // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION
    if (!response.ok && response.code == 403) {
      const errors: any = {
        msg: response.errors[0] + ' ' + textActionConcat,
        status: 'error',
      };

      await setMsgSnack(errors);
      await setAlertSnack(true);

      return false;
    }

    // 403 EL DATO YA SE ENCUENTRA REGISTRADO
    if (!response.ok && response.code == 409) {
      const errors: any = {
        msg: response.errors[0] + ' ' + textActionConcat,
        status: 'error',
      };

      await setMsgSnack(errors);
      await setAlertSnack(true);

      return false;
    }

    // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO
    if (!response.ok && response.code == 400) {
      const errors: any = [];

      response.errors.forEach((element: any) => {
        errors.push({
          type: 'error',
          text: element,
        });
      });

      setMessagesAlerts(errors);
      return false;
    }

    return true;
  };

  return (
    <React.Fragment>
      <ModalSessionExpired open={modalSessionExpired} />

      <MultipleSnackbars
        messagesList={messagesAlerts}
        position={'bottom-left'}
        autoClose={timeAlert}
      />

      <SnackAlert
        open={alert_snack}
        onclick={setAlertSnack}
        text={msgSnack.msg}
        severity={msgSnack.status}
      />

      <BootstrapDialog
        onClose={handleCloseT}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth={'md'}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Editar Novedad Turno
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseT}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Grid>
            <Formik
              initialValues={formInitialValues}
              validationSchema={currentValidationSchema}
              onSubmit={_handleSubmit}
            >
              <>
                <Form id={formId}>
                  <EditarNovedadTurno formField={formField} />

                  <Button
                    disabled={isSubmitting}
                    style={{ margin: 5, float: 'right' }}
                    type="submit"
                    variant="contained"
                    color={'primary'}
                  >
                    {btnText}
                  </Button>
                </Form>
              </>
            </Formik>
          </Grid>
        </DialogContent>
        <DialogActions></DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};
